/** Indentação do payload formatado — 2 espaços, como o resto do portal. */
const INDENT = 2

/**
 * Formata o corpo cru enviado pelo processador para leitura.
 *
 * O payload chega como a string que o banco/adquirente mandou: quase sempre JSON numa linha só,
 * às vezes com centenas de campos. Sem indentar, a inspeção de um webhook que falhou vira rolagem
 * horizontal.
 *
 * Payload que NÃO é JSON (form-urlencoded, XML, texto de erro) é devolvido como veio — reformatar
 * o que não se entende esconderia justamente o caso que se está investigando.
 *
 * @param payload Corpo cru, como veio da API.
 * @returns O payload indentado, ou o original quando não for JSON.
 */
export const formatPayload = (payload?: string): string => {
  const value = payload?.trim()
  if (!value) return ""

  try {
    return JSON.stringify(JSON.parse(value), null, INDENT)
  } catch {
    return payload as string
  }
}
